module.exports = __webpack_public_path__ + "static/media/ic_calendar_grey.44bb39f7.svg";